import { Box, Typography } from '@coolblue-development/freddy';
import CloseConversationButton from '../../Common/CloseConversationButton';
import CassieShowButton from '../../../../CassieContainer/CassieShowButton';
import { fetchContact } from '../../../../../utils/fetchContact';
import CheckmarkIcon from '../../../Icons/CheckMarkIcon';
import { useEmailContext } from '../../../../../contexts/EmailContext';
import { endAndCloseConversation } from '../../../../../utils/endConversation';

export const EmailTopPanel = (): JSX.Element => {
  const { selectedEmail, emailData, emailThreads, isReplyOpen, setClosingContactId, outboundContactId } =
    useEmailContext();
  const contact = selectedEmail ? fetchContact(selectedEmail) : null;
  const isConnected = contact?.isConnected();
  const label = 'Close contact';
  const isOutboundDraft = selectedEmail !== null && selectedEmail === outboundContactId;
  const emailHasContent = selectedEmail ? !!emailThreads[selectedEmail]?.messages.some(m => m.bodyHtml) : false;

  const onClose =
    contact && isConnected && !isReplyOpen && !isOutboundDraft && selectedEmail
      ? (onError: () => void) => {
          setClosingContactId(selectedEmail);
          endAndCloseConversation(contact, () => {
            setClosingContactId(null);
            onError();
          });
        }
      : undefined;

  return (
    <Box
      sx={{
        height: '60px',
        background: '#fff',
        borderBottom: '#DDDDDD 1px solid',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '15px',
        gap: '10px',
        position: 'sticky',
        top: 0,
        zIndex: 100
      }}
    >
      {selectedEmail && emailHasContent && (
        <Typography
          variant="h4"
          sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, minWidth: 0 }}
          data-testid="email-top-panel-subject"
        >
          {emailData[selectedEmail]?.subject || 'No subject'}
        </Typography>
      )}

      <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0, flex: 1, justifyContent: 'end' }}>
        <CassieShowButton />
        {
          <CloseConversationButton
            icon={<CheckmarkIcon />}
            label={label}
            disabled={!contact || isOutboundDraft || isReplyOpen || !emailHasContent}
            contact={contact}
            onClose={onClose}
          />
        }
      </Box>
    </Box>
  );
};
